hp(window).on('load', (e) => {
    /**
     * This part of JS close all Bootstrap Collapses when some of the, is open
     */
    const categoriesBtns = hp('.left-menu').find('.category-menu');
    let togglers = [];
    let collapses = [];

    categoriesBtns.each((colItem) => {
        colItem = hp(colItem);
        let collapseBtn = colItem.find('.category-name').elem
        let collapse = colItem.find('.category-collapse').elem

        togglers.push(collapseBtn)
        collapses.push(new bootstrap.Collapse(collapse, {
            toggle: !hp(collapse).find('.category-wiki.active').isEmpty()
        }))
    })

    hp(togglers).each((toggleBtn) => {
        hp(toggleBtn).on('click', (e) => {
            collapses.forEach((col, i) => {
                col.hide()
            })
        })
    })
    /**
     *
     */
})
